// extracted by mini-css-extract-plugin
export default {"container":"Burger_container__3Z2uw","nav":"Burger_nav__34lqr","link":"Burger_link__X-16M","x":"Burger_x__xDvvX","img":"Burger_img__vJHA0"};